import { Injectable } from '@angular/core';
import { Headers, Http, RequestOptions, Response, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthenticationService {
  public token: string;
  private url = environment.apiUrl;
  private contentType = { 'Content-Type': 'application/json' };

  constructor(private http: Http) {
    const token = JSON.parse(localStorage.getItem('token'));
    this.token = token;
  }

  login(username: string, password: string): Observable<boolean> {
    const url = `${this.url}/get-token/`;
    const headers: Headers = new Headers(this.contentType);
    return this.http.post(url, JSON.stringify({
      username: username,
      password: password
    }), new RequestOptions({ headers: headers }))
      .map((response: Response) => {
        const token = response.json() && response.json().token;
        if (token) {
          this.token = token;
          localStorage.setItem('token', JSON.stringify(this.token));
          return true;
        } else {
          return false;
        }
      }).catch(this.handleLoginError);
  }

  getUserInfo() {
    const url = `${this.url}/user/`;
    return this.http.get(url, this.getAuthOptions()).map(res => {
      const user = res.json();
      localStorage.setItem('currentUser', JSON.stringify(user));
      res.json();
    });
  }

  getAuthOptions(): RequestOptions {
    const authHeaders = new Headers(this.contentType);
    authHeaders.append('Authorization', 'Token ' + this.token);
    return new RequestOptions({ headers: authHeaders });
  }

  getExcelOptions(): RequestOptions {
    const authHeaders = new Headers(this.contentType);
    authHeaders.append('Authorization', 'Token ' + this.token);
    return new RequestOptions({ headers: authHeaders, responseType: ResponseContentType.Blob });
  }

  logout(): void {
    this.token = null;
    localStorage.removeItem('currentUser');
    localStorage.removeItem('token');
  }

  isLoggedIn(): boolean {
    return this.token != null;
  }

  isAdmin(): boolean {
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    const isAdmin = currentUser && currentUser.is_staff;
    return isAdmin;
  }

  getCurrentUser(): any {
    return JSON.parse(localStorage.getItem('currentUser'));
  }

  private handleLoginError(error: Response | any) {
    let errMsg: string;
    if (error instanceof Response) {
      if (error.status === 400) {
        errMsg = 'Usuario o contraseña incorrecto';
      } else {
        const body = error.json() || '';
        const err = body.error || JSON.stringify(body);
        errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
      }
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./src/app/_shared/services/authentication.service.ts